<template>
    <div id="home-page">
        <!-- Header section -->
        <global-header v-bind:fontSize="fontSize"></global-header>
        <div id="content-section">
        <!-- Main section -->
        <main :aria-label="$t('main')">
            <div id="main">
                <div class="container" id="home-page-container" :lang="`${$i18n.locale}`" :style="'padding-top:'+sideDivHeight+'px'">
                    <div class="side-div-home-page" ref="sidediv" :lang="`${$i18n.locale}`">
                        <div class="side-div-home-page-body pb-4" ref="sidedivbody">
                            <h1
                                id="head-title"
                                class="pb-lg-4"
                                data-aos="show-from-bottom"
                                data-aos-easing="from-bottom-easing"
                                data-aos-delay="400"
                            >
                                {{ $t("canada-eco-modiale") }}
                            </h1>
                            <h2
                                class="head-text"
                                data-aos="show-from-bottom"
                                data-aos-easing="from-bottom-easing"
                                data-aos-delay="400"
                            >
                                {{ $t("choose-a-way") }}
                            </h2>
                        </div>
                        <div class="triangle" :style="'border-right-width:'+triangleWidth+'px'"></div>
                    </div>
                    <div class="row">
                        <div class="col-lg-8 col-md-6 home-pib home-section" :lang="`${$i18n.locale}`">
                            <router-link :to="{ name: `pib:${$i18n.locale}`}"  class="d-flex flex-column justify-content-center">
                                <h3
                                    class="home-header mb-0"
                                    data-aos="show-from-bottom"
                                    data-aos-easing="from-bottom-easing"
                                    data-aos-delay="400"
                                    :class="{'text-center':this.windowWidth > 992}"
                                >
                                    <img src="@/assets/images/pib_icon.png" :alt="$t('pib-icon')" />
                                    <div class="d-flex align-items-center"
                                        :class="{
                                            'justify-content-center' : this.windowWidth > 992,
                                            'justify-content-between' : this.windowWidth <= 992
                                        }"
                                    >
                                        <span v-if="this.windowWidth > 992">
                                            &nbsp;
                                        </span>
                                        <h3 class="label-section label-section-pib" :lang="`${$i18n.locale}`">
                                            {{ $t('gross-domestic') }}
                                        </h3>
                                        <span class="ps-2 chevron-after-category">
                                            <font-awesome-icon :icon="['fas','chevron-right']"/>
                                        </span>
                                    </div>
                                </h3>
                            </router-link>
                        </div>
                        <div class="col-lg-4 col-md-6 home-immigration home-section" :lang="`${$i18n.locale}`">
                            <router-link :to="{ name: `immigration:${$i18n.locale}`}" class="d-flex flex-column justify-content-center">
                                <h3
                                    class="home-header mb-0"
                                    data-aos="show-from-bottom"
                                    data-aos-easing="from-bottom-easing"
                                    data-aos-delay="400"
                                    :class="{'text-center':this.windowWidth > 992}"
                                >
                                    <img src="@/assets/images/immigration_icon.png" :alt="$t('immigration-icon')" />
                                    <div class="d-flex align-items-center"
                                        :class="{
                                            'justify-content-center' : this.windowWidth > 992,
                                            'justify-content-between' : this.windowWidth <= 992
                                        }"
                                    >
                                        <span v-if="this.windowWidth > 992">
                                            &nbsp;
                                        </span>
                                        <h3 class="label-section label-section-immigration">
                                            {{ $t('human-resource') }}
                                        </h3>
                                        <span class="ps-3 chevron-after-category">
                                            <font-awesome-icon :icon="['fas','chevron-right']"/>
                                        </span>
                                    </div>
                                </h3>
                            </router-link>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-8 col-md-6 home-analyse home-section" :lang="`${$i18n.locale}`">
                            <router-link :to="{ name: `analyse:${$i18n.locale}`}" class="d-flex flex-column justify-content-center">
                                <h3
                                    class="home-header mb-0"
                                    data-aos="show-from-bottom"
                                    data-aos-easing="from-bottom-easing"
                                    data-aos-delay="400"
                                    :class="{'text-center':this.windowWidth > 992}"
                                >
                                    <img src="@/assets/images/analyse_icon.png" :alt="$t('analyse-icon')" />
                                    <div class="d-flex align-items-center"
                                        :class="{
                                            'justify-content-center' : this.windowWidth > 992,
                                            'justify-content-between' : this.windowWidth <= 992
                                        }"
                                    >
                                        <span v-if="this.windowWidth > 992">
                                            &nbsp;
                                        </span>
                                        <h3 class="label-section label-section-analyse">
                                            {{ $t('foreign-investment') }}
                                        </h3>
                                        <span class="ps-1 chevron-after-category">
                                            <font-awesome-icon :icon="['fas','chevron-right']"/>
                                        </span>
                                    </div>
                                </h3>
                            </router-link>
                        </div>
                        <div class="col-lg-4 col-md-6 home-exchange home-section" :lang="`${$i18n.locale}`" >
                            <router-link :to="{ name: `exchange:${$i18n.locale}`}" class="d-flex flex-column justify-content-center">
                                <h3
                                    class="home-header mb-0"
                                    data-aos="show-from-bottom"
                                    data-aos-easing="from-bottom-easing"
                                    data-aos-delay="400"
                                    :class="{'text-center':this.windowWidth > 992}"
                                >
                                    <img src="@/assets/images/exchange_icon.png" :alt="$t('exchange-icon')" />
                                    <div class="d-flex align-items-center"
                                        :class="{
                                            'justify-content-center' : this.windowWidth > 992,
                                            'justify-content-between' : this.windowWidth <= 992
                                        }"
                                    >
                                        <span v-if="this.windowWidth > 992">
                                            &nbsp;
                                        </span>
                                        <h3 class="label-section label-section-exchange">
                                            {{ $t('commercial-exchanges') }}
                                        </h3>
                                        <span class="ps-3 chevron-after-category">
                                            <font-awesome-icon :icon="['fas','chevron-right']"/>
                                        </span>
                                    </div>
                                </h3>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </main>

        <!-- Footer section -->
        <global-footer></global-footer>
        </div>
    </div>
</template>
<script>
import { EventBus }    from '@/helpers/EventBus.js';
export default {

    props: ["fontSize"],
    data() {
        return {
            triangleWidth: 0,
            sideDivHeight: 0,
            windowWidth: window.innerWidth,
        }
    },
    mounted() {
        window.addEventListener("resize", this.updateTraiangleAndWindowWidth);
        EventBus.$on('grow-font', this.updateTraiangleAndWindowWidth);
        EventBus.$on('settingsChanged', this.updateTraiangleAndWindowWidth);
        EventBus.$on('locale-changed', this.updateTraiangleAndWindowWidth);
        this.updateTraiangleAndWindowWidth();
    },
    destroyed() {
        window.removeEventListener("resize", this.myEventHandler);
    },
    methods: {
        /**
         * Change the width of the triangle so that it fits with div above it
         * Update the width of window so that we can use it to assign or not some css classes
         */
        updateTraiangleAndWindowWidth() {
            setTimeout(() => {
                this.triangleWidth  = this.$refs.sidediv.clientWidth;
                this.windowWidth    = window.innerWidth;
                this.sideDivHeight  = 0;

                if (this.windowWidth < 992) {
                    this.sideDivHeight = this.$refs.sidedivbody.clientHeight + 65;
                }
            },10)
        },
    },
};
</script>
